import { useState } from 'react';
import { NavLink, Outlet, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface NavItem { slug: string; label: string; }

const SECTIONS: Array<{ heading?: string; items: NavItem[] }> = [
  {
    items: [
      { slug: '', label: 'home' },
      { slug: 'quickstart', label: 'quickstart' },
    ],
  },
  {
    items: [
      { slug: 'api', label: 'API reference' },
      { slug: 'standards', label: 'all 11 specifications' },
      { slug: 'family-preamble', label: 'family preamble' },
      { slug: 'emrg', label: 'EMRG overview' },
      { slug: 'messages', label: 'message library' },
      { slug: 'codec', label: 'codec integration' },
    ],
  },
  {
    items: [
      { slug: 'meshtastic', label: 'meshtastic setup' },
      { slug: 'fastalert', label: 'fastalert.now bridge' },
      { slug: 'mcp', label: 'MCP integration' },
    ],
  },
  {
    items: [
      { slug: 'certification', label: 'certification' },
      { slug: 'reference', label: 'reference tables' },
      { slug: 'c-codec', label: 'embedded C SDK' },
    ],
  },
];

/** Public shell for `/docs/*` routes: section nav sidebar and content outlet. */
export function DocsLayout() {
  const { isAuthenticated } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="docs-layout">
      <aside className="docs-sidebar">
        <div className="docs-sidebar-heading">
          <div><h1>AstdZ</h1><div className="muted-label">docs</div></div>
          <button className="btn docs-menu-toggle" type="button" aria-expanded={menuOpen} aria-controls="docs-navigation" onClick={() => setMenuOpen((value) => !value)}>{menuOpen ? 'Close menu' : 'Menu'}</button>
        </div>
        <div id="docs-navigation" className={`docs-navigation${menuOpen ? ' is-open' : ''}`}>
        <hr className="divider" />
        {SECTIONS.map((section, i) => (
          <div key={i}>
            <nav>
              {section.items.map((item) => (
                <NavLink
                  key={item.slug}
                  to={item.slug ? `/docs/${item.slug}` : '/docs'}
                  end={item.slug === ''}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
            {i < SECTIONS.length - 1 && <hr className="divider" />}
          </div>
        ))}
        <hr className="divider" />
        {isAuthenticated ? (
          <Link to="/dashboard" className="muted-label" style={{ textDecoration: 'none' }}>
            ← dashboard
          </Link>
        ) : (
          <Link to="/login" className="muted-label" style={{ textDecoration: 'none' }}>
            → sign in
          </Link>
        )}
        <hr className="divider" />
        <nav aria-label="Interactive demonstration"><a href="https://astdz.com/how-it-works/">how it works demo ↗</a></nav>
        </div>
      </aside>
      <main className="docs-main">
        <Outlet />
      </main>
    </div>
  );
}
